import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function FAQ() {
  const { t } = useTranslation("home");
  const items = t("faq.items", { returnObjects: true }) as Array<{
    q: string;
    a: string;
  }>;
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const left = items.slice(0, 4);
  const right = items.slice(4, 8);

  return (
    <section id="faq" className="bg-brand-cream py-20 md:py-[120px] w-full">
      <div className="max-w-[1200px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-3xl md:text-[48px] text-brand-text text-center mb-12 md:mb-16">
          {t("faq.h2")}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          <div className="flex flex-col gap-6 md:gap-8">
            {left.map((item, i) => (
              <div key={i} className="border-b border-brand-border pb-6 md:pb-8">
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="flex items-start justify-between gap-4 w-full text-left"
                >
                  <h4 className="font-geist font-bold text-lg md:text-xl text-brand-text leading-snug">
                    {item.q}
                  </h4>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    {openIndex === i ? (
                      <i className="ri-subtract-line text-brand-blue text-xl"></i>
                    ) : (
                      <i className="ri-add-line text-brand-blue text-xl"></i>
                    )}
                  </div>
                </button>
                {openIndex === i && (
                  <p className="font-geist text-sm md:text-base text-brand-text/75 leading-relaxed mt-3">
                    {item.a}
                  </p>
                )}
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-6 md:gap-8">
            {right.map((item, i) => (
              <div key={i + 4} className="border-b border-brand-border pb-6 md:pb-8">
                <button
                  onClick={() => setOpenIndex(openIndex === i + 4 ? null : i + 4)}
                  className="flex items-start justify-between gap-4 w-full text-left"
                >
                  <h4 className="font-geist font-bold text-lg md:text-xl text-brand-text leading-snug">
                    {item.q}
                  </h4>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    {openIndex === i + 4 ? (
                      <i className="ri-subtract-line text-brand-blue text-xl"></i>
                    ) : (
                      <i className="ri-add-line text-brand-blue text-xl"></i>
                    )}
                  </div>
                </button>
                {openIndex === i + 4 && (
                  <p className="font-geist text-sm md:text-base text-brand-text/75 leading-relaxed mt-3">
                    {item.a}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}